import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_jym05_1",
  "input": "_input_jym05_5",
  "inputOpened": "_inputOpened_jym05_18",
  "selection": "_selection_jym05_32",
  "placeholder": "_placeholder_jym05_38",
  "list": "_list_jym05_42",
  "role": "_role_jym05_1",
  "iconBox": "_iconBox_jym05_66",
  "icon": "_icon_jym05_66",
  "iconReverse": "_iconReverse_jym05_76",
  "opened": "_opened_jym05_82",
  "selectedRole": "_selectedRole_jym05_91",
  "selectedRoleIcon": "_selectedRoleIcon_jym05_95",
  "selectedRoleTitle": "_selectedRoleTitle_jym05_101",
  "roleDescription": "_roleDescription_jym05_108"
};